import React from "react";
import Typography from "@material-ui/core/Typography";
import Image from "react-bootstrap/Image";
import { toAbsoluteUrl } from "../../../../../../../_metronic";
const Vision = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Our Vision
      </Typography>
      <Typography paragraph variant="h5">
        We are driven by innovation and a desire to help our customer's
        business.
      </Typography>
      <Typography paragraph variant="body1">
        We are on a mission to provide the cheapest way for our customers to
        have an integrated platform in a single ecosystem that helps the
        enterprise’s business process simply and efficiently. Cheap does not
        mean having limited features and benefits, but it means we provide
        end-to-end business process solutions in an effective and simple way.
        There is no point to have a complex process but triggering a massive
        expense cost.
      </Typography>
      <div className="row justify-content-center mt-5">
        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
          <Typography component="span" align="center">
            <Image
              src={toAbsoluteUrl(
                `/invifo/illustrations/invifo_platform_vision.png`
              )}
              style={{
                maxHeight: "600px",
              }}
              alt="Avatar"
              roundedCircle
              fluid
            />
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Vision;
